// extracted by mini-css-extract-plugin
export default {"breadCrumbsIcon":"styles-scoped__breadCrumbsIcon--mFTQM","iconSettingBusinessType":"styles-scoped__iconSettingBusinessType--ylEBh"};